import { createStore, applyMiddleware, combineReducers } from "redux";
import { thunk } from "redux-thunk";
import {
  reducerGetCategories,
  reducerGetNews,
  reducerGetProjects,
} from "../reducer/reducerGetData";
import {
  reducerAddComments,
  reducerAddContact,
  reducerAddItem,
} from "../reducer/reducerPostData";
import cartReducer from "../reducer/AddToCart";

const rootReducer = combineReducers({
  projects: reducerGetProjects,
  categories: reducerGetCategories,
  news: reducerGetNews,
  cart: cartReducer,
  addItemState: reducerAddItem,
  addCommentsState: reducerAddComments,
  addContactState: reducerAddContact,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;